export * from 'vue/dist/vue.esm-bundler.js';

let fallbackId = 0;

export function useId() {
  return `vue-${++fallbackId}`;
}
